const State = {
  shopList: [],
  maxSortNumber: 0
}

export default State
